/**
 * CheckUp evaluation-pillar BAND — the one rule that grades a pillar score
 * (0–100) as excellent, good, attention or critical.
 *
 * The server grades every pillar it sends (`evaluationPillars[].band`) and the
 * clients draw the band they are sent (root CLAUDE.md rule 9). It used to be
 * graded in THREE client copies — journey-web's `scoreBand` / `scoreBarColor`
 * and citizen-mobile's `scoreBandKey` / `pillarBandColor` / `scoreBand` —
 * which agreed only because someone kept them in step by hand.
 *
 * Lower bounds are INCLUSIVE: 80 is excellent, 79.9 good.
 */

export const CHECKUP_PILLAR_BANDS = ['excellent', 'good', 'attention', 'critical'] as const;
export type CheckUpPillarBand = (typeof CHECKUP_PILLAR_BANDS)[number];

/** Inclusive lower bound of each band above `critical`. */
export const CHECKUP_PILLAR_BAND_LOWER_BOUNDS = {
  excellent: 80,
  good: 70,
  attention: 60,
} as const;

export function pillarScoreBand(score: number): CheckUpPillarBand {
  if (score >= CHECKUP_PILLAR_BAND_LOWER_BOUNDS.excellent) return 'excellent';
  if (score >= CHECKUP_PILLAR_BAND_LOWER_BOUNDS.good) return 'good';
  if (score >= CHECKUP_PILLAR_BAND_LOWER_BOUNDS.attention) return 'attention';
  return 'critical';
}

/** The i18n key of each band — guarded against en.json in dynamic-key-coverage.spec.ts. */
export const CHECKUP_PILLAR_BAND_LABEL_KEY = {
  excellent: 'checkup.results.bandExcellent',
  good: 'checkup.results.bandGood',
  attention: 'checkup.results.bandAttention',
  critical: 'checkup.results.bandCritical',
} as const satisfies Record<CheckUpPillarBand, string>;
